module.exports = __webpack_public_path__ + "img/sprite-2.b1d7f136.webp";